/**
 * @file Main entry point for the Content Pickers ES6 wrapper
 * @author Box
 */

import FilePicker from './FilePicker';
import FolderPicker from './FolderPicker';
import ContentPicker from './ContentPicker';

global.Box = global.Box || {};
global.Box.FilePicker = FilePicker;
global.Box.FolderPicker = FolderPicker;
global.Box.ContentPicker = ContentPicker;
